import { Box, CircularProgress, Typography } from "@mui/material";

// Placeholder tile shown in an image thumbnail grid while a photo upload
// (camera capture or manual pick) is in flight, sized to match the real
// thumbnails/upload tile around it.
export default function UploadingImageTile({ size = 120, progress = 0 }) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        borderRadius: "10px",
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "grey.100",
      }}
    >
      <CircularProgress variant="determinate" value={progress} size={32} />
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {progress}%
      </Typography>
    </Box>
  );
}
